import { Button } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { BetmenListActions } from '../../../../../common/components'
import { useBlackButtonStyle } from '../../../../../utils/styles/useBlackButtonStyle'
import isFunction from 'lodash/isFunction'

interface PatientDetailsActionsProps {
  isEditable: boolean
  onEdit?: () => void
  onDelete?: () => void
}
export const PatientDetailsActions: React.FC<PatientDetailsActionsProps> = ({
  isEditable,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation()
  const classes = useBlackButtonStyle()
  if (isEditable) {
    return (
      <BetmenListActions
        more={
          <>
            {isFunction(onEdit) && (
              <Button
                classes={{ textPrimary: classes.textPrimary }}
                variant="text"
                startIcon={<EditIcon />}
                sx={{ justifyContent: 'flex-start' }}
                onClick={onEdit}
              >
                {t('common:edit')}
              </Button>
            )}
            {isFunction(onDelete) && (
              <Button
                classes={{ textPrimary: classes.textPrimary }}
                variant="text"
                color="error"
                startIcon={<DeleteIcon />}
                sx={{ justifyContent: 'flex-start' }}
                onClick={onDelete}
              >
                {t('common:delete')}
              </Button>
            )}
          </>
        }
      />
    )
  }
  return null
}
